import React from 'react'
import ResponsiveXYFrame from "semiotic/lib/ResponsiveXYFrame"
import { curveCatmullRom } from "d3-shape"
import cs from 'classnames'
import palette from 'helpers/palette'
import './style.css'


/* global API */

const StatPeople = () => {

    const colorSectorProgression = [7, 11, 0, 4, 8, 1, 5, 9, 2, 6, 10, 3,]
    const colorIndexProgression = [5, 3, 6, 4, 7, 2, 8, 1, 0]

    const initialFrameProps = {
        size: [800, 400],
        margin: { left: 80, bottom: 90, right: 40, top: 40 },
        responsiveWidth: true,

        lines: [
            {'title': '', coordinates: [{date: '2020-02-20', count: 0, day: 0}]}
        ],

        // Style
        lineStyle: (d, i) => ({
            stroke: palette
                [colorSectorProgression[i % colorSectorProgression.length]]
                [colorIndexProgression[Math.floor(i / colorSectorProgression.length) % 9]]
                .HEX,
            strokeWidth: 3,
            fill: "none"
        }),
        lineType: {
            type: "line",
            interpolator: curveCatmullRom
        },

        // Axes
        xAccessor: el => new Date(el.date),
        yAccessor: "count",
        yExtent: [0],

        axes: [
            {
                orient: "left",
                label: { name: "Сообщений", locationDistance: 60 }
            },
            {
                orient: "bottom",
                tickFormat: e => {
                    let d = new Date(e);
                    return (
                        <text className={cs({'weekend': !d.getDay() || (d.getDay() === 6)})}>
                            {d.getDate() + '.' + (
                            d.getMonth() + 1 < 10
                                ? '0' + (d.getMonth() + 1)
                                : (d.getMonth() + 1)
                            )}
                        </text>
                    )
                }
            }
        ],

        // Tooltip
        hoverAnnotation: true,
        tooltipContent: d => <div className="stat__tooltip">{d.title}<br />{d.count}</div>,
    }

    const [frameProps, setFrameProps] = React.useState(initialFrameProps)
    const [userList, setUserList] =  React.useState([])

    React.useEffect(() => {
        API.instance().getUserActivityStat().then(stat => {

            const newUserList = []
            frameProps.lines = stat.map(item => {
                newUserList.push(item.user.name + ' ' + item.user.surname);
                return {
                    title: item.user.name + ' ' + item.user.surname,
                    coordinates: item.stat.map(el => ({
                        ...el,
                        ...{'title': item.user.name + ' ' + item.user.surname}
                    }))
                }
            })

            const newFrameProps = frameProps;
            newFrameProps.axes[1].tickValues = []
                .concat.apply(
                    [],
                    stat.map(item => item.stat.map(el => el.date))
                )
                .filter( (value, index, self) => self.indexOf(value) === index )
                .map(e => new Date(e))

            setFrameProps(newFrameProps)
            setUserList(newUserList)
        })
    }, [frameProps])

    return (
        <div>
            <ResponsiveXYFrame {...frameProps} />

            <div className="legend container">
                {userList?.map((title, index) =>
                    <div className="legend__item" key={index} style={{ color: palette
                        [colorSectorProgression[index % colorSectorProgression.length]]
                        [colorIndexProgression[Math.floor(index / colorSectorProgression.length) % 9]]
                        .HEX }}>
                        ◼︎ {title}
                    </div>
                )}
            </div>
        </div>
    )
}

export default StatPeople
